import { render } from "./Login.vue?vue&type=template&id=483916e5&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=483916e5&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483916e5"]])

export default __exports__